import React from 'react';
import PropTypes from 'prop-types';
import ColumnModel from '../../models/datasource/column';

export default function ColumnName({column, separator=' '}) {
    return (
        <span className="column-name">
            <span className="column-name-table">{column.table.label}{separator}</span>
            <span className="column-name-column">{column.label}</span>
        </span>
    );
}

ColumnName.propTypes = {
    column: PropTypes.instanceOf(ColumnModel).isRequired,
};
